import React from "react";
import { useTranslation } from "react-i18next";

import AreaContent from "shared/ui/toolbar/tools/measurements/measuretools/AreaContent";
import CoordinateContent from "shared/ui/toolbar/tools/measurements/measuretools/CoordinateContent";
import DistanceContent from "shared/ui/toolbar/tools/measurements/measuretools/DistanceContent";
import LinrefContent from "shared/ui/toolbar/tools/measurements/measuretools/LinrefContent";
import OrthogonalDistanceContent from "shared/ui/toolbar/tools/measurements/measuretools/OrthogonalContent";
import ProfileContent from "shared/ui/toolbar/tools/measurements/measuretools/ProfileContent";
import SurveyWheelContent from "shared/ui/toolbar/tools/measurements/measuretools/SurveyWheelContent";
import VerticalDistanceContent from "shared/ui/toolbar/tools/measurements/measuretools/VerticalDistanceContent";
import {
  Area,
  AreaActive,
  AreaFilled,
  Coordinate,
  CoordinateActive,
  CoordinateFilled,
  Distance,
  DistanceActive,
  DistanceFilled,
  Linref,
  LinrefActive,
  LinrefFilled,
  OrthogonalDistance,
  OrthogonalDistanceActive,
  OrthogonalDistanceFilled,
  Profile,
  ProfileActive,
  ProfileFilled,
  SurveyWheel,
  SurveyWheelActive,
  SurveyWheelFilled,
  VerticalDistance,
  VerticalDistanceActive,
  VerticalDistanceFilled,
} from "shared/common/utils/icons/measurementIcons";

export interface MeasurementType {
  id: string;
  title: string;
  description: string;
  tooltip: string;
  content: JSX.Element | string;
  icon: JSX.Element;
  filledIcon: JSX.Element;
  activeIcon: JSX.Element;
  isBlockedOnOldView: boolean;
}

const measurementTools = (): MeasurementType[] => {
  const { t } = useTranslation();

  return [
    {
      id: "coordinate",
      title: t("measurement.coordinate_title"),
      description: t("measurement.coordinate_description"),
      tooltip: t("tooltip.coordinate"),
      content: <CoordinateContent />,
      icon: <Coordinate />,
      filledIcon: <CoordinateFilled />,
      activeIcon: <CoordinateActive />,
      isBlockedOnOldView: false,
    },
    {
      id: "distance",
      title: t("measurement.distance_title"),
      description: t("measurement.distance_description"),
      tooltip: t("tooltip.distance"),
      content: <DistanceContent />,
      icon: <Distance />,
      filledIcon: <DistanceFilled />,
      activeIcon: <DistanceActive />,
      isBlockedOnOldView: false,
    },
    {
      id: "measureArea",
      title: t("measurement.area_title"),
      description: t("measurement.area_description"),
      tooltip: t("tooltip.area"),
      content: <AreaContent />,
      icon: <Area />,
      filledIcon: <AreaFilled />,
      activeIcon: <AreaActive />,
      isBlockedOnOldView: false,
    },
    {
      id: "verticalDistance",
      title: t("measurement.vertical_title"),
      description: t("measurement.vertical_description"),
      tooltip: t("tooltip.vertical"),
      content: <VerticalDistanceContent />,
      icon: <VerticalDistance />,
      activeIcon: <VerticalDistanceActive />,
      filledIcon: <VerticalDistanceFilled />,
      isBlockedOnOldView: true,
    },
    {
      id: "surveyWheel",
      title: t("measurement.wheel_title"),
      description: t("measurement.wheel_description"),
      tooltip: t("tooltip.wheel"),
      content: <SurveyWheelContent />,
      icon: <SurveyWheel />,
      activeIcon: <SurveyWheelActive />,
      filledIcon: <SurveyWheelFilled />,
      isBlockedOnOldView: true,
    },
    {
      id: "orthogonalDistance",
      title: t("measurement.orthogonal_title"),
      description: t("measurement.orthogonal_description"),
      tooltip: t("tooltip.orthogonal"),
      content: <OrthogonalDistanceContent />,
      icon: <OrthogonalDistance />,
      activeIcon: <OrthogonalDistanceActive />,
      filledIcon: <OrthogonalDistanceFilled />,
      isBlockedOnOldView: true,
    },
    {
      id: "profile",
      title: t("measurement.profile_title"),
      description: t("measurement.profile_description"),
      tooltip: t("tooltip.profile"),
      content: <ProfileContent />,
      icon: <Profile />,
      activeIcon: <ProfileActive />,
      filledIcon: <ProfileFilled />,
      isBlockedOnOldView: true,
    },
    {
      id: "linref",
      title: t("measurement.linref_title"),
      description: t("measurement.linref_description"),
      tooltip: t("tooltip.linref"),
      content: <LinrefContent />,
      icon: <Linref />,
      activeIcon: <LinrefActive />,
      filledIcon: <LinrefFilled />,
      isBlockedOnOldView: true,
    },
  ];
};

export default measurementTools;
